/**
 * FontAwesome Configuration
 *
 * This file configures FontAwesome icons for the application.
 * Import this once at the top level to set up the icon library.
 */

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faChartLine,
  faHandshake,
  faBuilding,
  faAddressBook,
  faChartPie,
  faCogs,
  faGear,
  faExchangeAlt,
  faList,
  faUser,
  faSignOutAlt,
  faBars,
  faChevronUp,
  faChevronDown,
  faArrowTrendUp,
  faDollarSign,
  faCalendar,
  faFileInvoiceDollar,
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilter,
  faSearch,
  faDownload,
  faUpload,
  faSave,
  faCancel,
  faCheck,
  faTimes,
  faInfo,
  faWarning,
  faExclamationTriangle,
  faHome,
  faDashboard,
  faSpinner,
  faSortUp,
  faSortDown,
  faCircleDot
} from '@fortawesome/free-solid-svg-icons'

import { faMicrosoft } from '@fortawesome/free-brands-svg-icons'

// Add icons to the library
library.add(
  faChartLine,
  faHandshake,
  faBuilding,
  faAddressBook,
  faChartPie,
  faCogs,
  faGear,
  faExchangeAlt,
  faList,
  faUser,
  faSignOutAlt,
  faBars,
  faChevronUp,
  faChevronDown,
  faArrowTrendUp,
  faDollarSign,
  faCalendar,
  faFileInvoiceDollar,
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilter,
  faSearch,
  faDownload,
  faUpload,
  faSave,
  faCancel,
  faCheck,
  faTimes,
  faInfo,
  faWarning,
  faExclamationTriangle,
  faHome,
  faDashboard,
  faSpinner,
  faSortUp,
  faSortDown,
  faCircleDot,
  faMicrosoft
)
